export const styles = theme => ({
    background: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        padding: "2rem",
        margin: "2rem 0",
    },
    content: {
        marginTop: 32,
        "& h6": {
            fontWeight: 600
        }
    },
    description: {
        margin: "32px 0",
    },
});